import dynamic from 'next/dynamic';

const VariantComponent = dynamic(
  () => import(/* webpackChunkName: "boatWebCarouselCenteredVariant" */ './CenteredCarousel')
);

const MODIFER = 'centered-carousel';
const CenteredCarousel = {
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: componentSettings.modifier ? `${componentSettings.modifier} ${MODIFER}` : MODIFER
  }),
  VariantComponent
};

export default CenteredCarousel;
